<template>
  <v-container class="ma-0 pa-0" style="overflow: hidden;">
    <v-card class="pa-0 ma-0" align-items="center">
      <v-row justify="center" align="center" class="ma-1">
        <v-spacer></v-spacer>
        <v-icon left small color="success">mdi-calendar-month-outline</v-icon>
        <span class="subtitle">
          <b>Месечен отчет</b>
        </span>

        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-form ref="MonthlyRepRef" lazy-validation class="pa-3">
        <v-row class="ma-0 pa-0">
          <v-col cols="6">
            <v-autocomplete class="pa-1" hide-details :items="months" :item-text="'name'" :item-value="'id'" v-model="month" label="Месец" dense></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete class="pa-1" hide-details :items="years" v-model="year" label="Година" dense></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col cols="6" class="ma-0 pa-2">
            <v-checkbox class="pa-1 mt-0 mb-4" :ripple="false" hide-details :persistent-hint="false" :value="!isDetailed" @input="isDetailed = !$event" @change="isDetailed = !$event" label="Съкратен отчет" :color="isInDarkMode ? '' : 'grey'"></v-checkbox>
          </v-col>
          <v-col cols="6" class="ma-0 pa-2" align="end">
            <v-checkbox class="pa-1 mt-0 mb-4" :ripple="false" hide-details :persistent-hint="false" v-model="isDetailed" label="Детайлен отчет" :color="isInDarkMode ? '' : 'grey'"></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-2">
            <v-select v-model="repType" :items="repTypes" item-text="name" label="Тип на отчета" outlined dense required hide-details></v-select>
          </v-col>
        </v-row>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printMonthlyRep">
          <span>Отпечатай</span>
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Tremol from "../assets/fp/fp";
import Const from "../constants";

export default {
  data() {
    return {
      isDetailed: true,
      repTypes: [{ id: 0, name: "По данъчни групи" }, { id: 1, name: "По департаменти"}, { id: 2, name: "По плащания"}],
      repType: "По данъчни групи",
      date: new Date(),
      month: 0,
      year: 2020,
      years: [],
      months: [
        { id: 0, name: "Януари" },
        { id: 1, name: "Февруари" },
        { id: 2, name: "Март" },
        { id: 3, name: "Април" },
        { id: 4, name: "Май" },
        { id: 5, name: "Юни" },
        { id: 6, name: "Юли" },
        { id: 7, name: "Август" },
        { id: 8, name: "Септември" },
        { id: 9, name: "Октомври" },
        { id: 10, name: "Ноември" },
        { id: 11, name: "Декември" }
      ]
    };
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.MonthlyRep);
    },
    async printMonthlyRep() {
      try {
        let grabDate = (month, period) => {
          return new Date(this.year, month, period).toTremolFpString();
        };
        await this.fp.executeWithLoader(async () => {
          var idx = this.repTypes.find(i=>i.name == this.repType).id;
          switch (idx) {
            case 0:
              if (this.isDetailed) {
                await this.fp.PrintDetailedFMReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              } else {
                await this.fp.PrintBriefFMReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              }
              break;
            case 1:
              if (this.isDetailed) {
                await this.fp.PrintDetailedFMDepartmentsReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              } else {
                await this.fp.PrintBriefFMDepartmentsReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              }
              break;
            case 2:
            default:
              if (this.isDetailed) {
                await this.fp.PrintDetailedFMPaymentsReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              } else {
                await this.fp.PrintBriefFMPaymentsReportByDate(grabDate(this.month, 1), grabDate(this.month + 1, 0));
              }
              break;
          }
          this.fp.exitMode(Const.Modes.MonthlyRep);
        }, `Месечен отчет - ${this.months.find(month => month.id === this.month).name},  ${this.year} г.`);
      } catch (ex) {
        this.fp.handleException(ex);
      }
    }
  },
  mounted() {
    this.year = this.date.getFullYear();
    this.month = this.date.getMonth();
    this.isDetailed = false;
    for (let y = this.year; y >= 2010; y--) this.years.push(y);
  }
};
</script>